import { createFileRoute } from '@tanstack/react-router'
import { DataProtectionPage } from '../../components/data-protection/DataProtectionPage'

/** The DPO screen (spec 2026-10-03-02): gaps, retention queue, measures. */
export const Route = createFileRoute('/$org/data-protection')({
  component: DataProtectionPage,
})
